import { useEffect } from "react";
import { Link } from "react-router-dom";

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;600&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { scroll-behavior: smooth; }

  body {
    background: #050505;
    color: #f5f5f0;
    font-family: 'DM Sans', sans-serif;
    overflow-x: hidden;
  }

  :root {
    --black: #050505;
    --white: #f5f5f0;
    --navy: #1A2E6E;
    --magenta: #CC1A8A;
    --cyan: #00B4D8;
    --yellow: #F5C400;
    --blue: #2B4FCC;
    --gray: #111;
    --gray2: #1a1a1a;
    --muted: #666;
  }

  /* NAV */
  .sf-nav {
    position: fixed; top: 0; left: 0; right: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 20px 60px;
    background: rgba(5,5,5,.88);
    backdrop-filter: blur(16px);
    border-bottom: 1px solid rgba(255,255,255,.06);
    transition: border-color .3s;
  }
  .sf-nav-logo { display: flex; align-items: center; gap: 10px; text-decoration: none; }
  .sf-nav-wordmark { font-family: 'DM Sans', sans-serif; font-weight: 600; font-size: 15px; color: #f5f5f0; }
  .sf-nav-links { display: flex; align-items: center; gap: 36px; list-style: none; }
  .sf-nav-links a { color: #666; text-decoration: none; font-size: 13px; font-weight: 500; letter-spacing: .5px; transition: color .2s; }
  .sf-nav-links a:hover { color: #f5f5f0; }
  .sf-nav-cta { display: flex; align-items: center; gap: 12px; }
  .btn-nav { font-family:'DM Sans',sans-serif; font-size:13px; font-weight:600; letter-spacing:.5px; padding:10px 22px; border-radius:6px; text-decoration:none; transition:all .2s; border:none; cursor:pointer; }
  .btn-ig { background:transparent; color:#666; border:1px solid rgba(255,255,255,.1); }
  .btn-ig:hover { color:#f5f5f0; border-color:rgba(255,255,255,.3); }
  .btn-wpp { background:#25D366; color:#000; }
  .btn-wpp:hover { background:#1fb855; transform:translateY(-1px); }

  /* HERO */
  .sf-hero {
    position:relative; min-height:100vh;
    display:flex; flex-direction:column; align-items:center; justify-content:center;
    padding:120px 60px 80px; text-align:center; overflow:hidden;
  }
  .sf-hero-glow {
    position:absolute; inset:0; pointer-events:none;
    background:
      radial-gradient(ellipse 60% 50% at 50% 0%,rgba(44,79,204,.15) 0%,transparent 60%),
      radial-gradient(ellipse 40% 30% at 80% 80%,rgba(204,26,138,.08) 0%,transparent 50%),
      radial-gradient(ellipse 35% 25% at 15% 70%,rgba(0,180,216,.07) 0%,transparent 50%);
  }
  .sf-hero-tag {
    display:inline-flex; align-items:center; gap:8px;
    font-size:11px; font-weight:600; letter-spacing:3px; text-transform:uppercase;
    color:#00B4D8; border:1px solid rgba(0,180,216,.25); padding:6px 18px; border-radius:100px;
    margin-bottom:32px; animation:fadeUp .6s ease both;
  }
  .sf-hero-tag::before {
    content:''; width:6px; height:6px; border-radius:50%; background:#00B4D8;
    animation:pulse 2s infinite;
  }
  .sf-hero-diamond {
    width:110px; height:110px; margin:0 auto 28px;
    animation:fadeUp .6s .1s ease both, float 4s ease-in-out infinite;
    filter:drop-shadow(0 0 40px rgba(44,79,204,.4));
  }
  .sf-hero h1 {
    font-family:'Bebas Neue',sans-serif;
    font-size:clamp(72px,12vw,160px); line-height:.92; letter-spacing:2px;
    color:#f5f5f0; animation:fadeUp .6s .2s ease both; margin-bottom:8px;
  }
  .sf-hero h1 .grad {
    display:block;
    background:linear-gradient(90deg,#2B4FCC,#CC1A8A,#00B4D8);
    -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
  }
  .sf-hero-sub {
    font-size:clamp(15px,2vw,18px); font-weight:300; color:#666;
    max-width:520px; margin:24px auto 0; line-height:1.7;
    animation:fadeUp .6s .3s ease both;
  }
  .sf-hero-actions {
    display:flex; align-items:center; justify-content:center; gap:16px;
    margin-top:44px; flex-wrap:wrap; animation:fadeUp .6s .4s ease both;
  }
  .btn-primary {
    display:inline-flex; align-items:center; gap:8px;
    font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600; letter-spacing:.3px;
    padding:15px 32px; border-radius:8px; text-decoration:none;
    background:#CC1A8A; color:#fff; border:none; cursor:pointer; transition:all .2s;
  }
  .btn-primary:hover { background:#b51679; transform:translateY(-2px); box-shadow:0 12px 40px rgba(204,26,138,.35); }
  .btn-secondary {
    display:inline-flex; align-items:center; gap:8px;
    font-family:'DM Sans',sans-serif; font-size:14px; font-weight:600;
    padding:15px 32px; border-radius:8px; text-decoration:none;
    background:transparent; color:#f5f5f0; border:1px solid rgba(255,255,255,.15); transition:all .2s;
  }
  .btn-secondary:hover { border-color:rgba(255,255,255,.4); background:rgba(255,255,255,.05); }
  .sf-scroll-indicator {
    position:absolute; bottom:36px; left:50%; transform:translateX(-50%);
    display:flex; flex-direction:column; align-items:center; gap:8px;
    animation:fadeUp .6s .8s ease both;
  }
  .sf-scroll-line {
    width:1px; height:48px;
    background:linear-gradient(to bottom,transparent,rgba(255,255,255,.3));
    animation:scrollLine 2s ease-in-out infinite;
  }

  /* STATS */
  .sf-stats { display:grid; grid-template-columns:repeat(3,1fr); gap:1px; background:rgba(255,255,255,.06); border-top:1px solid rgba(255,255,255,.06); border-bottom:1px solid rgba(255,255,255,.06); }
  .sf-stat { background:#050505; padding:52px 40px; text-align:center; }
  .sf-stat-num { font-family:'Bebas Neue',sans-serif; font-size:64px; line-height:1; background:linear-gradient(135deg,#2B4FCC,#00B4D8); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
  .sf-stat-label { font-size:13px; color:#666; margin-top:8px; letter-spacing:.5px; }

  /* ABOUT */
  .sf-about-grid { display:grid; grid-template-columns:1fr 1fr; gap:80px; align-items:center; }
  .sf-about-text p { font-size:16px; font-weight:300; color:#999; line-height:1.8; margin-bottom:20px; }
  .sf-about-text p strong { color:#f5f5f0; font-weight:500; }

  /* ── FIXED CARDS GRID ── */
  .sf-about-cards {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 16px;
    align-items: stretch;
  }
  .sf-about-card {
    background: #1a1a1a;
    border: 1px solid rgba(255,255,255,.06);
    border-radius: 12px;
    padding: 28px 24px;
    transition: border-color .3s, transform .3s;
    display: flex;
    flex-direction: column;
  }
  .sf-about-card:hover { border-color:rgba(44,79,204,.4); transform:translateY(-4px); }
  .sf-about-card-icon { font-size:28px; margin-bottom:12px; }
  .sf-about-card h4 { font-family:'Bebas Neue',sans-serif; font-size:24px; letter-spacing:1px; color:#f5f5f0; margin-bottom:6px; }
  .sf-about-card p { font-size:12px; color:#666; line-height:1.6; }

  /* SERVICES */
  .sf-services { background:#111; }
  .sf-services-header { display:flex; align-items:flex-end; justify-content:space-between; margin-bottom:60px; gap:40px; }
  .sf-services-intro { font-size:16px; font-weight:300; color:#666; line-height:1.7; max-width:420px; flex-shrink:0; }
  .sf-services-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:2px; background:rgba(255,255,255,.05); border-radius:16px; overflow:hidden; }
  .sf-service-card { background:#0d0d0d; padding:36px 32px; position:relative; transition:background .3s; }
  .sf-service-card::before { content:''; position:absolute; top:0; left:0; width:3px; height:0; background:linear-gradient(to bottom,#2B4FCC,#CC1A8A); transition:height .4s ease; }
  .sf-service-card:hover { background:#121212; }
  .sf-service-card:hover::before { height:100%; }
  .sf-service-num { font-family:'Bebas Neue',sans-serif; font-size:13px; letter-spacing:2px; color:rgba(255,255,255,.15); margin-bottom:16px; }
  .sf-service-name { font-size:15px; font-weight:600; color:#f5f5f0; line-height:1.4; margin-bottom:10px; transition:color .3s; }
  .sf-service-card:hover .sf-service-name { color:#00B4D8; }
  .sf-service-desc { font-size:12px; color:#666; line-height:1.6; }

  /* PROCESS */
  .sf-process-steps { display:grid; grid-template-columns:repeat(4,1fr); gap:2px; margin-top:60px; background:rgba(255,255,255,.05); border-radius:12px; overflow:hidden; }
  .sf-process-step { background:#050505; padding:40px 32px; position:relative; }
  .sf-process-step::after { content:'→'; position:absolute; right:-12px; top:50%; transform:translateY(-50%); color:rgba(255,255,255,.15); font-size:18px; z-index:1; }
  .sf-process-step:last-child::after { display:none; }
  .sf-step-num { font-family:'Bebas Neue',sans-serif; font-size:56px; line-height:1; background:linear-gradient(135deg,rgba(44,79,204,.4),rgba(204,26,138,.4)); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; margin-bottom:16px; }
  .sf-step-title { font-size:15px; font-weight:600; color:#f5f5f0; margin-bottom:10px; }
  .sf-step-desc { font-size:12px; color:#666; line-height:1.6; }

  /* CTA */
  .sf-cta { background:linear-gradient(135deg,#1A2E6E 0%,#0d1a4a 50%,#1a0830 100%); overflow:hidden; position:relative; }
  .sf-cta::before { content:''; position:absolute; top:-60%; left:-20%; width:80%; height:200%; background:radial-gradient(ellipse,rgba(44,79,204,.2) 0%,transparent 60%); pointer-events:none; }
  .sf-cta::after { content:''; position:absolute; bottom:-40%; right:-10%; width:60%; height:150%; background:radial-gradient(ellipse,rgba(204,26,138,.15) 0%,transparent 60%); pointer-events:none; }
  .sf-cta-inner { position:relative; z-index:1; max-width:1200px; margin:0 auto; padding:100px 60px; display:flex; align-items:center; justify-content:space-between; gap:60px; }
  .sf-cta-actions { flex-shrink:0; display:flex; flex-direction:column; gap:14px; align-items:flex-start; }
  .btn-wpp-big { display:inline-flex; align-items:center; justify-content:center; gap:12px; font-family:'DM Sans',sans-serif; font-size:15px; font-weight:600; padding:18px 36px; border-radius:10px; text-decoration:none; background:#25D366; color:#000; transition:all .2s; white-space:nowrap; width:100%; box-sizing:border-box; }
  .btn-wpp-big:hover { background:#1fba58; transform:translateY(-2px); box-shadow:0 16px 48px rgba(37,211,102,.3); }
  .btn-ig-big { display:inline-flex; align-items:center; justify-content:center; gap:12px; font-family:'DM Sans',sans-serif; font-size:15px; font-weight:600; padding:18px 36px; border-radius:10px; text-decoration:none; background:transparent; color:#f5f5f0; border:1px solid rgba(255,255,255,.2); transition:all .2s; white-space:nowrap; width:100%; box-sizing:border-box; }
  .btn-ig-big:hover { border-color:rgba(255,255,255,.5); background:rgba(255,255,255,.06); }

  /* FOOTER */
  .sf-footer { border-top:1px solid rgba(255,255,255,.06); padding:48px 60px; display:flex; align-items:center; justify-content:space-between; }
  .sf-footer-copy { font-size:12px; color:#666; }
  .sf-footer-links { display:flex; flex-wrap:wrap; justify-content:center; gap:12px 28px; }
  .sf-footer-links a { font-size:12px; color:#666; text-decoration:none; transition:color .2s; }
  .sf-footer-links a:hover { color:#f5f5f0; }

  /* SECTION COMMON */
  .sf-section-inner { max-width:1200px; margin:0 auto; padding:100px 60px; }
  .sf-section-tag { font-size:11px; font-weight:600; letter-spacing:3px; text-transform:uppercase; color:#00B4D8; margin-bottom:16px; display:flex; align-items:center; gap:10px; }
  .sf-section-tag::before { content:''; display:block; width:24px; height:1px; background:#00B4D8; }
  .sf-section-tag.yellow { color:#F5C400; }
  .sf-section-tag.yellow::before { background:#F5C400; }
  .sf-section-title { font-family:'Bebas Neue',sans-serif; font-size:clamp(48px,6vw,80px); line-height:.95; letter-spacing:1px; color:#f5f5f0; margin-bottom:20px; }
  .sf-section-title span { color:#CC1A8A; }

  /* REVEAL */
  .reveal { opacity:0; transform:translateY(30px); transition:opacity .7s ease,transform .7s ease; }
  .reveal.visible { opacity:1; transform:translateY(0); }

  /* ANIMATIONS */
  @keyframes fadeUp { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
  @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.3} }
  @keyframes float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
  @keyframes scrollLine { 0%,100%{opacity:.3;transform:scaleY(.5);transform-origin:top} 50%{opacity:1;transform:scaleY(1)} }

  /* RESPONSIVE */
  @media (max-width:900px) {
    .sf-nav { padding:16px 24px; }
    .sf-nav-links { display:none; }
    .sf-hero { padding:100px 24px 60px; }
    .sf-section-inner { padding:72px 24px; }
    .sf-stats { grid-template-columns:1fr; }
    .sf-about-grid { grid-template-columns:1fr; gap:48px; }
    .sf-services-header { flex-direction:column; align-items:flex-start; }
    .sf-services-grid { grid-template-columns:1fr; }
    .sf-process-steps { grid-template-columns:1fr 1fr; }
    .sf-cta-inner { flex-direction:column; }
    .sf-footer { flex-direction:column; gap:20px; text-align:center; }
  }

  /* LEGAL PAGES */
  .sf-legal { max-width:820px; margin:0 auto; padding:150px 60px 100px; }
  .sf-legal-updated { font-size:13px; color:#666; margin-bottom:48px; }
  .sf-legal h2 { font-family:'Bebas Neue',sans-serif; font-size:32px; letter-spacing:1px; color:#f5f5f0; margin:48px 0 16px; }
  .sf-legal p, .sf-legal li { font-size:16px; font-weight:300; color:#999; line-height:1.8; }
  .sf-legal p { margin-bottom:16px; }
  .sf-legal ul, .sf-legal ol { padding-left:22px; margin-bottom:16px; }
  .sf-legal li { margin-bottom:8px; }
  .sf-legal li::marker { color:#00B4D8; }
  .sf-legal strong { color:#f5f5f0; font-weight:500; }
  .sf-legal a { color:#00B4D8; text-decoration:none; overflow-wrap:anywhere; }
  .sf-legal a:hover { text-decoration:underline; }
  @media (max-width:900px) {
    .sf-legal { padding:110px 24px 72px; }
  }
`;

export const WppIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
    <path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.122 1.535 5.853L0 24l6.338-1.613A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.846 0-3.574-.5-5.065-1.373l-.364-.216-3.764.957.998-3.658-.239-.38A9.945 9.945 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
  </svg>
);

export const IgIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
  </svg>
);

export const WPP = "http://api.whatsapp.com/send?phone=5532999443605";
export const IG = "https://www.instagram.com/solutionfac";
export const EMAIL = "contato@solfac.com.br";

export function useSiteStyles() {
  useEffect(() => {
    if (!document.getElementById("sf-styles")) {
      const s = document.createElement("style");
      s.id = "sf-styles";
      s.textContent = css;
      document.head.appendChild(s);
    }
  }, []);
}

// Título e meta description por página, restaurando os padrões do index.html ao sair
export function usePageMeta(title, description) {
  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    const prevTitle = document.title;
    const prevDesc = meta?.getAttribute("content");
    document.title = title;
    meta?.setAttribute("content", description);
    return () => {
      document.title = prevTitle;
      if (prevDesc != null) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}

// Na home os links são âncoras da própria página; nas demais, apontam para a home
export function SiteNav({ onHome = false }) {
  const base = onHome ? "" : "/";
  return (
    <nav className="sf-nav">
      <Link to="/" className="sf-nav-logo">
        <img src="/icon800.png" alt="Solfac" width={28} height={28} />
        <span className="sf-nav-wordmark">Solution Factory</span>
      </Link>
      <ul className="sf-nav-links">
        {["#sobre", "#servicos", "#processo", "#contato"].map((h, i) => (
          <li key={i}>
            <a href={base + h}>
              {["Sobre", "Serviços", "Processo", "Contato"][i]}
            </a>
          </li>
        ))}
      </ul>
      <div className="sf-nav-cta">
        <a
          href={IG}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-nav btn-ig"
        >
          Instagram
        </a>
        <a
          href={WPP}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-nav btn-wpp"
        >
          WhatsApp
        </a>
      </div>
    </nav>
  );
}

export function SiteFooter() {
  return (
    <footer className="sf-footer">
      <div className="sf-footer-copy">
        © 2025 Solution Factory — Todos os direitos reservados · Juiz de Fora,
        MG
      </div>
      <div className="sf-footer-links">
        <a href={WPP} target="_blank" rel="noopener noreferrer">
          WhatsApp
        </a>
        <a href={IG} target="_blank" rel="noopener noreferrer">
          Instagram
        </a>
        <Link to="/privacidade">Política de Privacidade</Link>
        <Link to="/exclusao-de-dados">Exclusão de Dados</Link>
      </div>
    </footer>
  );
}
